import { useScale } from './useScale';

export interface Props {
  offset?: number;
  size: number;
  end: number;
}

export const useAxisScale = ({ offset = 0, size, end }: Props) =>
  useScale({
    domain: { start: offset, end: offset + size },
    range: { start: 0, end },
  });
